import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { DeleteExamMethods } from './DeleteExamMethods';
import { FormExamMethods } from './FormExamMethods';
import { Dialog } from 'primereact/dialog';

export const ModalExamMethods = (props) => {

    const {
        modal, toggleModal, method, loadingModal,
        name, code, id_machine_models, id_method, machineModels, selectMachineModels, methods, handleInputChange, validaciones, handleSelectValues,
        saveCreate, saveUpdate, saveDelete, loadingCreate
    } = props;

    const modalTitle =
            method === "create"
                ? "Creación de método"
                : method === "update"
                ? "Actualización de método"
                : "Eliminar método";
    return (
         <Dialog
            header={modalTitle}
            visible={modal}
            modal
            dismissableMask
            onHide={toggleModal}
            className="tiny-dialog"
            headerStyle={{
                backgroundColor: "#0d3b59",
                color: "white",
                fontWeight: "bold",
                letterSpacing: "0.5px",
            }}
        >

            {
                method === "create" ?
                    <FormExamMethods
                        button="Crear nuevo método"
                        {...{ toggleModal, loadingModal, name, code, id_machine_models, id_method, machineModels, selectMachineModels, methods, handleInputChange, handleSelectValues, validaciones, loadingCreate, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormExamMethods
                            button="Actualizar método"
                            {...{ toggleModal, loadingModal, name, code, id_machine_models, machineModels, selectMachineModels, handleInputChange, handleSelectValues, validaciones, loadingCreate, methodAction: saveUpdate }}
                        />
                        : <DeleteExamMethods {...{ toggleModal, loadingModal, name, saveDelete }} />
            }
        </Dialog>
        
    )
}
